/**
 * Module formats minutes into hh:mm, even accross 24hrs
 *
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module minutes-format.js
 * @class MinutesFormat
 * @since 0.8.0
*/

/**
 * Formats minutes into hh:mm, even accross 24hrs.
 *
 * @method formatHourMin
 * @param minutes {number} amount of minutes
 * @return {String} formatted as 'hh:mm'
 * @since 0.8.0
 */

const formatHourMin = minutes => {
    let prepend = '',
        hours, remainingMinutes, negative;
    if (typeof minutes !== 'number') {
        return ' ';
    }
    negative = minutes < 0;
    if (negative) {
        minutes = -minutes;
        prepend = '-';
    }
    hours = Math.floor(minutes / 60);
    remainingMinutes = minutes - (60 * hours);
    return prepend + hours.toString().padStart(2, '0') + ':' + remainingMinutes.toString().padStart(2, '0');
};

module.exports = formatHourMin;
